import { ContactRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'

export const ContactsTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const { t } = useTranslation()

  return (
    <SiteNavigationTab
      id={id}
      title={t('nav.contacts')}
      icon={ContactRound}
      isSelected={isSelected}
      isCollapsed={isCollapsed}
      onClick={onClick}
    />
  )
}
